import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Dashboard from './Dashboard';
import { decodeColumnsFromUrl } from '../../utils/DashboardColumnsUrlParams';

export const DashboardWrapper = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // Create a history-like object for backwards compatibility
    const history = {
        push: navigate,
        replace: (path) => navigate(path, { replace: true }),
        // Add other history methods as needed
    };

    const sharedColumns = decodeColumnsFromUrl();

    return <Dashboard location={location} history={history} sharedColumns={sharedColumns} />;
}; 